import * as action_types from "../actions/action_types";

const initialState = {
  userProfile: {
    name: "",
    // language: "",
    // state: "",
    email: "",
    phone_number: "",
    // locale: null,
  },
  error: false,
};
const set_user_profile = (userProfile, state) => {
  return {
    ...state,
    userProfile,
  };
}
  
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.SET_USER_PROFILE:
      return set_user_profile(action.data, state);
      case action_types.DELETE_USER_PROFILE:
      return set_user_profile(action.data, state);
    case action_types.ERROR_FETCH_USER_PROFILE:
      return {
        ...state,
        error: true,
      };

    case action_types.CLEAR_USER_PROFILE_ERROR:
      return {
        ...state,
        error: false,
      };
    default:
      return state;
  }
};

export default reducer;
